// src/i18n/en/status.ts
// English counterpart of `i18n/es/status.ts` — see there for context.
export const status = {
  name: 'Status |||| Status',
  subtitle: 'Data reception gaps by source, for IT and support',

  table: {
    title: 'Sources covering this property',
    source: 'Source',
    kind: 'Kind',
    deliveryClass: 'Delivery class',
    status: 'Status',
    totalGaps: 'Total gaps',
    gapsByCounter: 'Gaps by counter',
    empty: 'No source covers this property in the chosen period.',
  },

  kinds: {
    Kiosk: 'Kiosk',
    Gateway: 'Gateway',
    Oci: 'Online check-in',
    BackOffice: 'Management panel',
    DispenserShim: 'Dispenser',
    Partner: 'External integration',
    Locks: 'Locks',
    Assistant: 'Guest assistant',
    other: 'Other source',
  },

  delivery: {
    Durable: 'Guaranteed',
    Lossy: 'Not guaranteed',
    other: 'Unknown',
  },

  states: {
    Active: 'Active',
    Suspended: 'Suspended',
    Revoked: 'Revoked',
    other: 'Unknown',
  },

  help: {
    title: 'Status',
    description:
      "Insight's own register of data reception gaps, by source, for the chosen property and period (defaults to the last 48 hours). This is the internal, property-scoped variant; a public, anonymous variant is a pending product decision.",
    features: {
      list: 'Every source shows its kind, delivery class, status, and its total and per-counter gaps.',
    },
    tips: {
      property: 'Switch property at the top left; the default period is the last 48 hours.',
    },
  },
};

export default status;
